import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

//-------------------------------------------------------------

const PresetFileCard = ({ item, onSelectHandler, isSelected }) => {


  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "24px",
        borderBottom: "1px solid #EEEEEE",
        background: isSelected && "#F9F9F9",
        cursor: "pointer",
      }}
      onClick={() => onSelectHandler(item)}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "24px" }}>
        <Box
          sx={{
            width: "68px",
            height: "68px",
            borderRadius: "4px",
            border: isSelected
              ? "1px solid #000"
              : "1px solid rgba(38, 38, 38, 0.1)",
          }}
        >
          {item?.logo && <img src={item?.logo} alt="" width={'100%'} height='100%' style={{
             border: isSelected
              ? "1px solid #000"
              : "1px solid rgba(38, 38, 38, 0.1)",}} />}
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <span style={{ fontSize: "14px", fontWeight: isSelected && "bold" }}>
            {item?.name}
          </span>
          <span style={{ fontSize: "10px", fontWeight: isSelected && "bold" }}>
            {item?.width && item?.height
              ? `Size: ${item?.width} * ${item?.height} ,`
              : ""}{" "}
            {item?.background ? `Background: ${item?.background} ,` : ""}{" "}
            {item?.extension ? `Format: ${item?.extension}` : ""}
          </span>
        </Box>
      </Box>
      {isSelected && (
        <img
          src="/icons/uploadFile/checked.svg"
          alt=""
          width="26px"
          height="26px"
        />
      )}
    </div>
  );
};

export default PresetFileCard;
